module.exports = __webpack_public_path__ + "img/icon-test.5f8c7f53.png";